<script setup>
import { IonApp, IonRouterOutlet, IonLoading } from "@ionic/vue";
import { useAppStore } from "./stores/app";
// import { onMounted } from "vue";
// import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { supabase } from "@/lib/supabaseClient";
import { useUserStore } from "./stores/user";
// import ReloadPrompt from "./components/ReloadPrompt.vue";
import {
  // ActionPerformed,
  // PushNotificationSchema,
  PushNotifications,
  // Token,
} from "@capacitor/push-notifications";
import { watch } from "vue";
import { Capacitor } from "@capacitor/core";
import { SendIntent } from "send-intent";
import { useRouter } from "vue-router";
import { App } from "@capacitor/app";

console.log("Initializing App.vue");

const router = useRouter();

const createSessionFromUrl = async (url) => {
  const parsedUrl = new URL(url);
  // Supabase puts tokens in the hash fragment, fall back to query string
  const hashParams = new URLSearchParams(parsedUrl.hash.replace("#", ""));
  const access_token =
    hashParams.get("access_token") ||
    parsedUrl.searchParams.get("access_token");
  const refresh_token =
    hashParams.get("refresh_token") ||
    parsedUrl.searchParams.get("refresh_token");
  if (!access_token) return;
  const { data, error } = await supabase.auth.setSession({
    access_token,
    refresh_token,
  });
  if (error) throw error;
  return data.session;
};

App.addListener("appUrlOpen", async function (event) {
  // Example url: https://beerswift.app/tabs/tabs2
  // slug = /tabs/tabs2
  if (event.url) {
    await createSessionFromUrl(event.url);
  }

  const slug = event.url.split(".at").pop();

  // We only push to the route if there is a slug present
  if (slug) {
    console.log("Navigating to slug:", slug);
    router.push({
      path: slug,
    });
  }
});

App.addListener("appRestoredResult", (data) => {
  console.log("Restored state:", data);
});

App.addListener("appStateChange", ({ isActive }) => {
  console.log("App state changed. Is active?", isActive);
});

const checkSendIntentReceived = async () => {
  SendIntent.checkSendIntentReceived()
    .then((result) => {
      if (result) {
        console.log("SendIntent received");
        console.log(JSON.stringify(result));
        let query = {};
        if (result.type?.startsWith("image/") && result.url) {
          try {
            query = { imagePath: decodeURIComponent(result.url) };
          } catch (e) {
            query = { imagePath: result.url };
          }
          router.push({ name: "Dashboard", query });
        } else {
          let resultText = result.url || result.title;
          if (resultText) {
            try {
              resultText = decodeURIComponent(resultText);
            } catch (e) {
              console.error("Error decoding result text:", e);
            }
            if (resultText.startsWith("https://")) {
              query = { url: resultText };
            } else {
              query = { text: resultText };
            }
            router.push({ name: "Dashboard", query });
          }
        }
      }
    })
    .catch((err) => console.error(err));
};
checkSendIntentReceived();
window.addEventListener("sendIntentReceived", () => {
  checkSendIntentReceived();
});

const setupPushNotifications = () => {
  console.log("Setting up push notifications");
  // Request permission to use push notifications
  // iOS will prompt user and return if they granted permission or not
  // Android will just grant without prompting
  PushNotifications.requestPermissions().then((result) => {
    if (result.receive === "granted") {
      // Register with Apple / Google to receive push via APNS/FCM
      PushNotifications.register();
    } else {
      // Show some error
    }
  });

  // On success, we should be able to receive notifications
  PushNotifications.addListener("registration", async (token) => {
    // alert("Push registration success, token: " + token.value);
    console.log(token.value);
    const { data, error } = await supabase.from("profiles").upsert({
      id: userStore.user.uid,
      fcm_token: token.value,
      updated_at: new Date().toISOString(),
    });
    if (error) {
      // alert("Error updating FCM token:", error);
      console.error("Error updating FCM token:", error);
    } else {
      // alert("FCM token updated successfully:", data);
    }
  });

  // Some issue with our setup and push will not work
  PushNotifications.addListener("registrationError", (error) => {
    // alert("Error on registration: " + JSON.stringify(error));
    console.log("Error on registration: " + JSON.stringify(error));
  });

  // Show us the notification payload if the app is open on our device
  PushNotifications.addListener("pushNotificationReceived", (notification) => {
    // alert("Push received: " + JSON.stringify(notification));
    console.log("Push received: " + JSON.stringify(notification));
  });

  // Method called when tapping on a notification
  PushNotifications.addListener(
    "pushNotificationActionPerformed",
    (notification) => {
      // alert("Push action performed: " + JSON.stringify(notification));
      console.log("Push action performed: " + JSON.stringify(notification));
      const data = notification?.notification?.data;

      if (data?.url) {
        router.push(data.url);
      }
    },
  );
};

const userStore = useUserStore();

watch(
  () => userStore.user,
  (newUser) => {
    if (newUser) {
      console.log("User logged in, setting up push notifications");
      if (Capacitor.isNativePlatform()) {
        setupPushNotifications();
      }
    }
  },
  { immediate: true },
);

// Get registration token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
// const messaging = getMessaging();
// console.log("Requesting permission...");
// Notification.requestPermission().then((permission) => {
//   if (permission === "granted") {
//     console.log("Notification permission granted.");
//     getToken(messaging, {
//       vapidKey:
//         "BEItPQb6S5Lp1iKySr1I_aindkbkNDPjjmfjeGkLkwSmC_gUy9NAesCTEOG0SM6tPYd_tMFs5OvSmrjaf9081RI",
//     })
//       .then(async (currentToken) => {
//         if (currentToken) {
//           // Send the token to your server and update the UI if necessary
//           // ...
//           console.log(currentToken);
//           await supabase.from("profiles").upsert({
//             id: userStore.user.uid,
//             fcm_token: currentToken,
//             updated_at: new Date().toISOString(),
//           });
//         } else {
//           // Show permission request UI
//           console.log(
//             "No registration token available. Request permission to generate one."
//           );
//           // ...
//         }
//       })
//       .catch((err) => {
//         console.log("An error occurred while retrieving token. ", err);
//         // ...
//       });
//   }
// });

// onMessage(messaging, (payload) => {
//   console.log("Message received. ", payload);
//   // ...
// });

const appStore = useAppStore();
const appGetInfo = async () => {
  try {
    const info = await App.getInfo();
    appStore.appInfo = info;
    console.log("App Info:", info);
  } catch (error) {
    // console.error("Error getting app info:", error);
  }
};
appGetInfo();
</script>

<template>
  <ion-app>
    <ion-router-outlet />
    <ion-loading
      v-if="appStore.isLoading"
      :is-open="appStore.isLoading"
      @didDismiss="appStore.isLoading = false"
      :duration="60 * 1000"
      message="Bitte warten..."
    >
    </ion-loading>
    <!-- <reload-prompt /> -->
  </ion-app>
</template>
